<template>
  <div class="main" :style="defSty">
    <book-table
      :dataList="bookList"
      :isShowStatus="true"
      @deleteDone="deleteDone"
    ></book-table>
    <div class="submit-mask">
      <div class="submit-bg">
        <div></div>
        <div class="right-view">
          <span class="msg"
            >共教材
            <span style="color: #0082F0;">{{ bookList.length }}</span> 本</span
          >
          <div v-if="isUpdate" class="submit-btn" @click="updateAction()">
            更新清单
          </div>
          <div v-else class="submit-btn" style="background: #cccccc">
            更新清单
          </div>
        </div>
      </div>
    </div>
    <div class="mask-bg" v-if="isShowView">
      <div class="submit-modal">
        <div class="submit-head">
          <div class="close-btn" @click="hideModal">
            <img
              class="close-image"
              src="../../assets/img/close-white.png"
              alt=""
            />
          </div>
        </div>
        <div class="content">
          <img
            class="success-image"
            src="../../assets/img/success.png"
            alt=""
          />
          <div class="success-text">书单已更新成功，请等待校领导审核</div>
          <div class="success-btn" @click="goBackHome">返回首页</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Loading } from 'element-ui'
import { getBookStatusColor, getBookStatus } from '../../utils/tools'
import {
  fetchBookList,
  verificationMaterialSheetInfo,
  updateBookList,
} from '../../api/wapi'
import BookTable from '../chooseBooks/common/book-table'
Vue.component('book-table', BookTable)
export default {
  data() {
    return {
      defSty: {
        height: `${document.documentElement.clientHeight -200}px`,
      },
      tabelLoading: false,
      isShowView: false,
      sheetId: '',
      isUpdate: true,
      bookList: [],
    }
  },
  provide() {
    return {
      updateList: this.updateList,
    }
  },
  created() {
    this.sheetId = this.$route.query.fid
    this.loadList()
  },
  methods: {
    updateList() {
      this.loadList()
    },
    checkAdult(item) {
      return item.status < 2
    },
    loadList() {
      this.tabelLoading = true
      fetchBookList({ semesterId: this.sheetId })
        .then((result) => {
          this.tabelLoading = false
          if (result.data) {
            var list = result.data
            list.forEach((element) => {
              element.statusColor = getBookStatusColor(element.auditStatus)
              element.statusStr = getBookStatus(element.auditStatus)
              element.sheetId = this.sheetId
            })
            this.bookList = list
          }
        })
        .catch((err) => {})
    },
    goback() {
      this.$router.back()
    },
    goBackHome() {
      this.$router.push('/')
    },
    deleteDone(index) {
      this.bookList.splice(index, 1)
    },
    hideModal() {
      this.isShowView = false
    },
    // 提交成功
    updateAction() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(0,0,0,0.5)',
      })
      updateBookList({ semesterId: this.sheetId })
        .then((result) => {
          this.$nextTick(() => {
            loadingInstance.close()
          })
          this.isShowView = true
          // this.loadList()
        })
        .catch((err) => {
          this.$nextTick(() => {
            loadingInstance.close()
          })
        })
    },
  },
}
</script>

<style  scoped>
.maincen {
  margin: 0px 40px;
}
.main{
  position:relative;
}
.title-bg {
  height: 78px;
}
.bg {
  padding-top: 20px;
  height: 20px;
  display: flex;
  align-items: center;
}
.back {
  position: absolute;
  right: 40px;
  font-size: 12px;
  color: #666666;
}
.title-bar {
  width: 8px;
  height: 18px;
  background-color: #0082F0;
}
.title-text {
  margin-left: 8px;
  color: #333333;
  font-size: 18px;
}
.line {
  margin-top: 10px;
  width: 100%;
  height: 1px;
  background-color: #e6e6e6;
}
/* 提交成功弹框 */
.mask-bg {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  z-index: 100;
}
.submit-modal {
  margin-top: 200px;
  background-color: white;
  width: 380px;
  height: 300px;
}
.submit-head {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.close-btn {
  width: 44px;
  height: 44px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0082F0;
}
.close-image {
  width: 20px;
  height: 20px;
}
.content {
  margin: 0px;
  width: 100%;
  height: 100%;
  text-align: center;
}
.success-image {
  margin-top: 19px;
  width: 48px;
  height: 48px;
}
.success-text {
  font-size: 14px;
  color: #333333;
  text-align: center;
  margin-top: 19px;
}
.success-btn {
  color: white;
  background-color: #0082F0;
  width: 96px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  margin: auto;
  margin-top: 50px;
}
.submit-bg {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.right-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.submit-mask {
  position: absolute;
  display: flex;
  bottom: 0px;
  right: 0px;
  left: 0px;
  height: 56px;
  z-index: 0;
  background-color: white;
  -moz-box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.15);
}
.submit-btn {
  background-color: #0082F0;
  color: white;
  height: 56px;
  text-align: center;
  line-height: 56px;
  width: 100px;
  cursor: pointer;
}
.msg {
  font-size: 13px;
  color: #333333;
  margin-right: 10px;
}
</style>